"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoyaltyUnit = void 0;
const getLoyaltyUnit = (value, loyaltySettings) => {
    if (Math.abs(value) == 1) {
        return (loyaltySettings === null || loyaltySettings === void 0 ? void 0 : loyaltySettings.singularTerm) || 'Point';
    }
    return (loyaltySettings === null || loyaltySettings === void 0 ? void 0 : loyaltySettings.pluralTerm) || 'Points';
};
exports.getLoyaltyUnit = getLoyaltyUnit;
//# sourceMappingURL=loyaltyUnit.js.map